import { render, staticRenderFns } from "./AmountChangedModal.vue?vue&type=template&id=0647a1e6&scoped=true&"
import script from "./AmountChangedModal.vue?vue&type=script&lang=js&"
export * from "./AmountChangedModal.vue?vue&type=script&lang=js&"
import style0 from "./AmountChangedModal.vue?vue&type=style&index=0&id=0647a1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647a1e6",
  null
  
)

export default component.exports